import {t} from 'i18next'
import React from 'react'
import {ApprenticeGenderStatistic} from './ApprenticeGenderStatistic'
import {ApprenticeGenderStatisticByProfession} from './ApprenticeGenderStatisticByProfession'
import {ApprenticeInYearStatistic} from './ApprenticeInYearStatistic'
import {PeopleInSystemStatistic} from './PeopleInSystemStatistic'
import {SizeBarStatistic} from './SizeBarStatistic'

/**
 * TODO we do not differ in active/inactive
 * @constructor
 */
export const HrmStatistic = () => {
  return (
    <div>
      <h3 className={'col-12'}>
        <b>{t<string>('navigation.human_resources')}</b>
      </h3>

      <div className={'grid justify-content-center gap-4'}>
        <PeopleInSystemStatistic />
        <ApprenticeInYearStatistic />
        <SizeBarStatistic />
        <div className={'col-12 grid inline-flex mt-6 justify-content-center'}>
          <h4 className={'col-12'}>
            {t<string>('core.statistic.apprentices_gender')}
          </h4>
          <ApprenticeGenderStatistic />
          <ApprenticeGenderStatisticByProfession />
        </div>
      </div>
    </div>
  )
}